export type DirectoryCleaner = {
  id: string;
  name: string;
  role: string;
  rating: number;
  jobs: number;
  rate: number;
  bio: string;
  specialties: string[];
  languages: string[];
  city: string;
  yearsExperience: number;
  availability: "today" | "this-week" | "next-week";
  badge?: "top-rated" | "rising-star" | "eco-certified";
  image: string;
};

export const directoryCleaners: DirectoryCleaner[] = [
  {
    id: "maya",
    name: "Maya Olsen",
    role: "Senior Cleaner",
    rating: 4.96,
    jobs: 612,
    rate: 32,
    bio: "Six years with PureNest. Lives for a perfectly streak-free kitchen.",
    specialties: ["standard", "deep", "eco", "pet"],
    languages: ["English", "Norwegian"],
    city: "Brooklyn",
    yearsExperience: 6,
    availability: "today",
    badge: "top-rated",
    image:
      "https://readdy.ai/api/search-image?query=Friendly%20professional%20female%20house%20cleaner%20in%20her%2030s%20smiling%20warmly%20wearing%20clean%20olive%20green%20apron%2C%20soft%20cream%20studio%20background%2C%20editorial%20portrait%20photography%20natural%20warm%20light%20approachable%20trustworthy&width=600&height=720&seq=dir-cleaner-01&orientation=portrait",
  },
  {
    id: "daniel",
    name: "Daniel Reyes",
    role: "Deep-Clean Specialist",
    rating: 4.92,
    jobs: 438,
    rate: 36,
    bio: "Detail obsessive. Has been known to send before/after photos unprompted.",
    specialties: ["deep", "move", "standard"],
    languages: ["English", "Spanish"],
    city: "Manhattan",
    yearsExperience: 4,
    availability: "today",
    badge: "top-rated",
    image:
      "https://readdy.ai/api/search-image?query=Confident%20professional%20male%20house%20cleaner%20in%20his%20late%2020s%20smiling%20kindly%20wearing%20clean%20beige%20uniform%2C%20soft%20cream%20studio%20background%2C%20editorial%20portrait%20photography%20natural%20warm%20light%20friendly%20reliable&width=600&height=720&seq=dir-cleaner-02&orientation=portrait",
  },
  {
    id: "aisha",
    name: "Aisha Bennett",
    role: "Eco Clean Lead",
    rating: 5.0,
    jobs: 521,
    rate: 34,
    bio: "Plant-based products only. Will quietly reorganize your spice rack.",
    specialties: ["eco", "standard", "deep"],
    languages: ["English"],
    city: "Brooklyn",
    yearsExperience: 5,
    availability: "this-week",
    badge: "eco-certified",
    image:
      "https://readdy.ai/api/search-image?query=Friendly%20professional%20female%20house%20cleaner%20in%20her%20late%2020s%20warm%20smile%20wearing%20clean%20sage%20green%20apron%2C%20soft%20cream%20studio%20background%2C%20editorial%20portrait%20photography%20natural%20warm%20light%20approachable&width=600&height=720&seq=dir-cleaner-03&orientation=portrait",
  },
  {
    id: "liam",
    name: "Liam Hartwell",
    role: "Move-Out Pro",
    rating: 4.88,
    jobs: 287,
    rate: 30,
    bio: "Apartment turnover wizard. Carries his own ladder. Always early.",
    specialties: ["move", "standard"],
    languages: ["English"],
    city: "Queens",
    yearsExperience: 3,
    availability: "today",
    image:
      "https://readdy.ai/api/search-image?query=Professional%20male%20house%20cleaner%20in%20his%20early%2030s%20gentle%20smile%20wearing%20clean%20cream%20uniform%2C%20soft%20warm%20studio%20background%2C%20editorial%20portrait%20photography%20natural%20directional%20light%20friendly%20trustworthy&width=600&height=720&seq=dir-cleaner-04&orientation=portrait",
  },
  {
    id: "sofia",
    name: "Sofia Martinez",
    role: "Family Home Specialist",
    rating: 4.94,
    jobs: 489,
    rate: 33,
    bio: "Kid-rooms, pet hair, sticky surfaces — nothing fazes her.",
    specialties: ["standard", "pet", "deep"],
    languages: ["English", "Spanish"],
    city: "Brooklyn",
    yearsExperience: 5,
    availability: "this-week",
    image:
      "https://readdy.ai/api/search-image?query=Warm%20friendly%20female%20house%20cleaner%20in%20her%20mid%2030s%20with%20kind%20smile%20wearing%20clean%20cream%20apron%2C%20soft%20warm%20studio%20background%2C%20editorial%20portrait%20photography%20natural%20light%20approachable%20trustworthy&width=600&height=720&seq=dir-cleaner-05&orientation=portrait",
  },
  {
    id: "jonah",
    name: "Jonah Park",
    role: "Studio & Airbnb Pro",
    rating: 4.9,
    jobs: 356,
    rate: 31,
    bio: "Fast, quiet, surgical. Hosts love him. Lives for tight turnovers.",
    specialties: ["airbnb", "standard"],
    languages: ["English", "Korean"],
    city: "Manhattan",
    yearsExperience: 3,
    availability: "today",
    image:
      "https://readdy.ai/api/search-image?query=Professional%20male%20house%20cleaner%20in%20his%20late%2020s%20warm%20friendly%20smile%20wearing%20clean%20olive%20uniform%2C%20soft%20warm%20studio%20background%2C%20editorial%20portrait%20photography%20natural%20light%20approachable&width=600&height=720&seq=dir-cleaner-06&orientation=portrait",
  },
  {
    id: "elena",
    name: "Elena Voss",
    role: "Luxury Home Specialist",
    rating: 4.97,
    jobs: 402,
    rate: 38,
    bio: "Trained in marble, brass and bespoke linens. Treats every home like a gallery.",
    specialties: ["deep", "standard"],
    languages: ["English", "German"],
    city: "Manhattan",
    yearsExperience: 7,
    availability: "next-week",
    badge: "top-rated",
    image:
      "https://readdy.ai/api/search-image?query=Elegant%20professional%20female%20house%20cleaner%20in%20her%2030s%20with%20soft%20warm%20smile%20wearing%20clean%20cream%20linen%20apron%2C%20soft%20beige%20studio%20background%2C%20editorial%20portrait%20photography%20natural%20warm%20light%20refined%20trustworthy&width=600&height=720&seq=dir-cleaner-07&orientation=portrait",
  },
  {
    id: "marcus",
    name: "Marcus Bell",
    role: "Deep Clean Specialist",
    rating: 4.91,
    jobs: 318,
    rate: 35,
    bio: "Engineer turned cleaner. Built his own checklist system. Yes, really.",
    specialties: ["deep", "move", "standard"],
    languages: ["English"],
    city: "Queens",
    yearsExperience: 4,
    availability: "today",
    image:
      "https://readdy.ai/api/search-image?query=Calm%20professional%20male%20house%20cleaner%20in%20his%20early%2030s%20gentle%20friendly%20smile%20wearing%20clean%20charcoal%20gray%20uniform%2C%20soft%20cream%20studio%20background%2C%20editorial%20portrait%20photography%20natural%20warm%20light%20approachable&width=600&height=720&seq=dir-cleaner-08&orientation=portrait",
  },
  {
    id: "priya",
    name: "Priya Sharma",
    role: "Eco Clean Specialist",
    rating: 4.95,
    jobs: 376,
    rate: 33,
    bio: "Makes her own citrus cleaning spray. Your countertops will smell like joy.",
    specialties: ["eco", "standard", "pet"],
    languages: ["English", "Hindi"],
    city: "Brooklyn",
    yearsExperience: 4,
    availability: "today",
    badge: "eco-certified",
    image:
      "https://readdy.ai/api/search-image?query=Warm%20professional%20female%20house%20cleaner%20in%20her%20late%2020s%20with%20gentle%20smile%20wearing%20clean%20sage%20linen%20apron%2C%20soft%20cream%20studio%20background%2C%20editorial%20portrait%20photography%20natural%20warm%20light%20approachable%20friendly&width=600&height=720&seq=dir-cleaner-09&orientation=portrait",
  },
  {
    id: "noah",
    name: "Noah Whitfield",
    role: "Standard Clean Pro",
    rating: 4.84,
    jobs: 198,
    rate: 28,
    bio: "Reliable, easy-going, and great with chatty doormen. New to PureNest in 2025.",
    specialties: ["standard", "airbnb"],
    languages: ["English"],
    city: "Manhattan",
    yearsExperience: 2,
    availability: "this-week",
    badge: "rising-star",
    image:
      "https://readdy.ai/api/search-image?query=Young%20professional%20male%20house%20cleaner%20in%20his%20mid%2020s%20with%20friendly%20warm%20smile%20wearing%20clean%20cream%20uniform%2C%20soft%20warm%20studio%20background%2C%20editorial%20portrait%20photography%20natural%20directional%20light%20approachable%20fresh&width=600&height=720&seq=dir-cleaner-10&orientation=portrait",
  },
  {
    id: "yara",
    name: "Yara Hassan",
    role: "Deep Clean Specialist",
    rating: 4.93,
    jobs: 341,
    rate: 34,
    bio: "Quiet superpower: getting grout to look brand new. Don't ask, just watch.",
    specialties: ["deep", "standard", "eco"],
    languages: ["English", "Arabic"],
    city: "Queens",
    yearsExperience: 4,
    availability: "today",
    image:
      "https://readdy.ai/api/search-image?query=Friendly%20professional%20female%20cleaner%20in%20her%20early%2030s%20with%20warm%20smile%20wearing%20clean%20olive%20linen%20apron%2C%20soft%20beige%20studio%20background%2C%20editorial%20portrait%20photography%20natural%20warm%20light%20approachable%20kind&width=600&height=720&seq=dir-cleaner-11&orientation=portrait",
  },
  {
    id: "owen",
    name: "Owen Tate",
    role: "Move-Out Specialist",
    rating: 4.89,
    jobs: 264,
    rate: 31,
    bio: "Has done over 200 lease handovers. Knows every landlord checklist trick.",
    specialties: ["move", "deep"],
    languages: ["English"],
    city: "Brooklyn",
    yearsExperience: 3,
    availability: "this-week",
    image:
      "https://readdy.ai/api/search-image?query=Confident%20professional%20male%20house%20cleaner%20in%20his%20early%2030s%20relaxed%20smile%20wearing%20clean%20olive%20uniform%2C%20soft%20cream%20studio%20background%2C%20editorial%20portrait%20photography%20natural%20warm%20light%20friendly%20capable&width=600&height=720&seq=dir-cleaner-12&orientation=portrait",
  },
  {
    id: "rosa",
    name: "Rosa Linhares",
    role: "Senior Cleaner",
    rating: 4.95,
    jobs: 567,
    rate: 33,
    bio: "Five years strong. Famous for her hand-folded towel art. Yes, art.",
    specialties: ["standard", "airbnb", "deep"],
    languages: ["English", "Portuguese"],
    city: "Manhattan",
    yearsExperience: 5,
    availability: "today",
    badge: "top-rated",
    image:
      "https://readdy.ai/api/search-image?query=Cheerful%20professional%20female%20cleaner%20in%20her%20mid%2030s%20warm%20smile%20wearing%20clean%20cream%20linen%20apron%2C%20soft%20warm%20studio%20background%2C%20editorial%20portrait%20photography%20natural%20light%20approachable%20experienced&width=600&height=720&seq=dir-cleaner-13&orientation=portrait",
  },
  {
    id: "kai",
    name: "Kai Nakamura",
    role: "Airbnb Turnover Pro",
    rating: 4.92,
    jobs: 412,
    rate: 32,
    bio: "Sub-90-minute turnover specialist. Hosts beg him for repeat slots.",
    specialties: ["airbnb", "standard"],
    languages: ["English", "Japanese"],
    city: "Manhattan",
    yearsExperience: 4,
    availability: "today",
    image:
      "https://readdy.ai/api/search-image?query=Focused%20professional%20male%20cleaner%20in%20his%20late%2020s%20kind%20smile%20wearing%20clean%20beige%20uniform%2C%20soft%20warm%20cream%20studio%20background%2C%20editorial%20portrait%20photography%20natural%20directional%20light%20approachable%20refined&width=600&height=720&seq=dir-cleaner-14&orientation=portrait",
  },
  {
    id: "delia",
    name: "Delia Brooks",
    role: "Eco Clean Lead",
    rating: 4.98,
    jobs: 459,
    rate: 35,
    bio: "Only essential oils and microfiber. Allergy households swear by her.",
    specialties: ["eco", "standard", "pet"],
    languages: ["English"],
    city: "Brooklyn",
    yearsExperience: 6,
    availability: "this-week",
    badge: "eco-certified",
    image:
      "https://readdy.ai/api/search-image?query=Warm%20professional%20female%20eco%20cleaner%20in%20her%2030s%20gentle%20smile%20wearing%20clean%20natural%20linen%20apron%2C%20soft%20cream%20studio%20background%2C%20editorial%20portrait%20photography%20natural%20warm%20light%20approachable%20serene&width=600&height=720&seq=dir-cleaner-15&orientation=portrait",
  },
  {
    id: "theo",
    name: "Theo Kowalski",
    role: "Standard Clean Pro",
    rating: 4.86,
    jobs: 221,
    rate: 29,
    bio: "Easy-going, dog-loving, and absurdly fast with vacuums.",
    specialties: ["standard", "pet"],
    languages: ["English", "Polish"],
    city: "Queens",
    yearsExperience: 2,
    availability: "today",
    badge: "rising-star",
    image:
      "https://readdy.ai/api/search-image?query=Young%20friendly%20male%20cleaner%20in%20his%20mid%2020s%20bright%20smile%20wearing%20clean%20olive%20uniform%2C%20soft%20warm%20cream%20studio%20background%2C%20editorial%20portrait%20photography%20natural%20warm%20light%20approachable%20fresh%20energetic&width=600&height=720&seq=dir-cleaner-16&orientation=portrait",
  },
  {
    id: "nadia",
    name: "Nadia Petrova",
    role: "Deep Clean Specialist",
    rating: 4.94,
    jobs: 389,
    rate: 34,
    bio: "Trained in heritage homes. Vintage tile, wood floors, brass — her happy place.",
    specialties: ["deep", "standard"],
    languages: ["English", "Russian"],
    city: "Brooklyn",
    yearsExperience: 5,
    availability: "this-week",
    image:
      "https://readdy.ai/api/search-image?query=Composed%20professional%20female%20house%20cleaner%20in%20her%20early%2030s%20soft%20warm%20smile%20wearing%20clean%20cream%20linen%20apron%2C%20soft%20beige%20studio%20background%2C%20editorial%20portrait%20photography%20natural%20warm%20light%20approachable%20refined&width=600&height=720&seq=dir-cleaner-17&orientation=portrait",
  },
  {
    id: "isaac",
    name: "Isaac Greene",
    role: "Senior Cleaner",
    rating: 4.9,
    jobs: 502,
    rate: 33,
    bio: "Quiet professional. Walks in, transforms the space, walks out. Like a ninja.",
    specialties: ["standard", "deep", "move"],
    languages: ["English"],
    city: "Manhattan",
    yearsExperience: 6,
    availability: "today",
    image:
      "https://readdy.ai/api/search-image?query=Calm%20experienced%20male%20house%20cleaner%20in%20his%20mid%2030s%20friendly%20smile%20wearing%20clean%20charcoal%20gray%20uniform%2C%20soft%20warm%20cream%20studio%20background%2C%20editorial%20portrait%20photography%20natural%20directional%20light%20professional%20trustworthy&width=600&height=720&seq=dir-cleaner-18&orientation=portrait",
  },
  {
    id: "amelia",
    name: "Amelia Carter",
    role: "Studio Pro",
    rating: 4.87,
    jobs: 244,
    rate: 30,
    bio: "Small-space whisperer. Studios and 1-bedrooms look enormous after she's done.",
    specialties: ["standard", "airbnb"],
    languages: ["English"],
    city: "Manhattan",
    yearsExperience: 3,
    availability: "today",
    image:
      "https://readdy.ai/api/search-image?query=Friendly%20professional%20female%20cleaner%20in%20her%20late%2020s%20warm%20genuine%20smile%20wearing%20clean%20olive%20apron%2C%20soft%20cream%20studio%20background%2C%20editorial%20portrait%20photography%20natural%20warm%20light%20approachable%20bright&width=600&height=720&seq=dir-cleaner-19&orientation=portrait",
  },
  {
    id: "victor",
    name: "Victor Salazar",
    role: "Move-Out Pro",
    rating: 4.89,
    jobs: 312,
    rate: 32,
    bio: "Move-outs done before the U-Haul leaves. Lifts are no problem.",
    specialties: ["move", "deep", "standard"],
    languages: ["English", "Spanish"],
    city: "Queens",
    yearsExperience: 4,
    availability: "this-week",
    image:
      "https://readdy.ai/api/search-image?query=Strong%20friendly%20professional%20male%20house%20cleaner%20in%20his%20early%2030s%20kind%20smile%20wearing%20clean%20beige%20uniform%2C%20soft%20warm%20cream%20studio%20background%2C%20editorial%20portrait%20photography%20natural%20warm%20light%20approachable%20reliable&width=600&height=720&seq=dir-cleaner-20&orientation=portrait",
  },
  {
    id: "harper",
    name: "Harper Lin",
    role: "Eco Specialist",
    rating: 4.96,
    jobs: 367,
    rate: 33,
    bio: "Marine biology degree turned eco-cleaning crusader. Zero-waste pro.",
    specialties: ["eco", "standard", "airbnb"],
    languages: ["English", "Mandarin"],
    city: "Brooklyn",
    yearsExperience: 4,
    availability: "today",
    badge: "eco-certified",
    image:
      "https://readdy.ai/api/search-image?query=Warm%20friendly%20female%20cleaner%20in%20her%20late%2020s%20with%20gentle%20smile%20wearing%20clean%20sage%20green%20linen%20apron%2C%20soft%20cream%20studio%20background%2C%20editorial%20portrait%20photography%20natural%20warm%20light%20approachable%20serene&width=600&height=720&seq=dir-cleaner-21&orientation=portrait",
  },
  {
    id: "felix",
    name: "Felix Andersen",
    role: "Airbnb Turnover Pro",
    rating: 4.91,
    jobs: 298,
    rate: 31,
    bio: "Linen reset and welcome-basket setups included if you ask nicely.",
    specialties: ["airbnb", "standard"],
    languages: ["English", "Danish"],
    city: "Brooklyn",
    yearsExperience: 3,
    availability: "today",
    image:
      "https://readdy.ai/api/search-image?query=Friendly%20professional%20male%20cleaner%20in%20his%20late%2020s%20warm%20smile%20wearing%20clean%20cream%20linen%20uniform%2C%20soft%20warm%20beige%20studio%20background%2C%20editorial%20portrait%20photography%20natural%20warm%20light%20approachable%20refined&width=600&height=720&seq=dir-cleaner-22&orientation=portrait",
  },
  {
    id: "imani",
    name: "Imani Clarke",
    role: "Family Home Pro",
    rating: 4.93,
    jobs: 423,
    rate: 33,
    bio: "Mom of three. Knows every juice-stain trick. Loves a chaotic playroom.",
    specialties: ["standard", "pet", "deep"],
    languages: ["English"],
    city: "Queens",
    yearsExperience: 5,
    availability: "this-week",
    image:
      "https://readdy.ai/api/search-image?query=Warm%20welcoming%20female%20house%20cleaner%20in%20her%20mid%2030s%20with%20kind%20smile%20wearing%20clean%20olive%20apron%2C%20soft%20cream%20studio%20background%2C%20editorial%20portrait%20photography%20natural%20warm%20light%20approachable%20experienced%20caring&width=600&height=720&seq=dir-cleaner-23&orientation=portrait",
  },
  {
    id: "ethan",
    name: "Ethan Park",
    role: "Standard Clean Pro",
    rating: 4.85,
    jobs: 212,
    rate: 29,
    bio: "New favorite for tech-loft dwellers. Knows his way around tricky finishes.",
    specialties: ["standard", "airbnb"],
    languages: ["English", "Korean"],
    city: "Manhattan",
    yearsExperience: 2,
    availability: "next-week",
    badge: "rising-star",
    image:
      "https://readdy.ai/api/search-image?query=Young%20professional%20male%20house%20cleaner%20in%20his%20mid%2020s%20genuine%20smile%20wearing%20clean%20beige%20uniform%2C%20soft%20warm%20cream%20studio%20background%2C%20editorial%20portrait%20photography%20natural%20directional%20light%20approachable%20fresh%20capable&width=600&height=720&seq=dir-cleaner-24&orientation=portrait",
  },
];

export const specialtyFilters = [
  { id: "all", label: "All cleaners", icon: "ri-team-line" },
  { id: "standard", label: "Standard Clean", icon: "ri-home-smile-line" },
  { id: "deep", label: "Deep Clean", icon: "ri-sparkling-2-line" },
  { id: "move", label: "Move-Out", icon: "ri-truck-line" },
  { id: "airbnb", label: "Airbnb Turnover", icon: "ri-key-2-line" },
  { id: "eco", label: "100% Eco", icon: "ri-leaf-line" },
  { id: "pet", label: "Pet-friendly", icon: "ri-emotion-happy-line" },
] as const;

export const cityFilters = ["All cities", "Manhattan", "Brooklyn", "Queens"] as const;

export const availabilityFilters = [
  { id: "all", label: "Any time" },
  { id: "today", label: "Available today" },
  { id: "this-week", label: "This week" },
  { id: "next-week", label: "Next week" },
] as const;

export const sortOptions = [
  { id: "recommended", label: "Recommended" },
  { id: "rating", label: "Highest rated" },
  { id: "price-low", label: "Lowest rate" },
  { id: "price-high", label: "Highest rate" },
  { id: "jobs", label: "Most jobs" },
] as const;

export const specialtyMeta: Record<
  string,
  { label: string; icon: string }
> = {
  standard: { label: "Standard", icon: "ri-home-smile-line" },
  deep: { label: "Deep clean", icon: "ri-sparkling-2-line" },
  move: { label: "Move-out", icon: "ri-truck-line" },
  airbnb: { label: "Airbnb", icon: "ri-key-2-line" },
  eco: { label: "Eco", icon: "ri-leaf-line" },
  pet: { label: "Pet-friendly", icon: "ri-emotion-happy-line" },
};